

import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { useSelector } from "react-redux"
import {MdKeyboardArrowRight} from "react-icons/md"
import { useEffect } from "react"
import textFilter from "../../../../helper/textFilter"
import { handleActiveSelect } from "../../../../features/layout/layoutSlice"
import { setIsDurationStrict, updateTonajData } from "../../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice"

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    color: ${({theme}) => theme.mainTextColor};

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        padding-right: 30px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? theme.mainTextColor : theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        border-bottom-left-radius: ${({isActive}) => isActive && 0};
        border-bottom-right-radius: ${({isActive}) => isActive && 0};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
    }

    .arr-icon{
        position: absolute;
        right: 5px;
        top: 8px;
        transform: ${({isActive}) => isActive ? "rotate(90deg)": "rotate(0)"};
        font-size: 1.6rem;
        transition: .3s;
    }

    .options{
        position: absolute;
        top: 40px;
        background-color: ${({theme}) => theme.mainBgColor};
        display: flex;
        flex-direction: column;
        z-index: 10;
        width: 100%;
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? theme.mainTextColor : theme.mainBorderColor};
        border-color: ${({showErrors}) => showErrors && "var(--color-red)"};
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        max-height: 300px;
        overflow: auto;

        .option{
            width: 100%;
            padding: 9px 20px;
            cursor: pointer;


            &:hover{
                background-color: ${({theme}) => theme.secondaryBgColor};
            }
        }
    }
`

//! new
const InputTonaj = ({data, isRequired, labelText, name, inputWidth}) => {

    const [text, setText] = useState(data)
    const dispatch = useDispatch()

    const {activeSelect} = useSelector(state => state.layout)

    const {tonajOptions} = useSelector(state => state.nakliyeHesaplama)

    const [options, setOptions] = useState(tonajOptions)

    useEffect(()=> {
        setOptions(tonajOptions)
    },[tonajOptions])

    //! her zaman state deki değeri al
    useEffect(() => {
        setText(data)
    },[data])

    const handleChange = (e) => {
        const searchText = e.target.value
        dispatch(handleActiveSelect(name))

        if(!searchText){
            setOptions(tonajOptions)
            // dispatch(handleActiveSelect(null))
        }

        else{
            const result = textFilter(tonajOptions, searchText, "text")
            setOptions(result)
        }

        setText(searchText)
    }

    const handleOptionClick = (item) => {
        dispatch(setIsDurationStrict(false))
        dispatch(updateTonajData(item))
        dispatch(handleActiveSelect(null))
    }

  return (
    <Container onClick={() => dispatch(handleActiveSelect((activeSelect && activeSelect === name) ? null : name))} value={text} radius={"5px"} isActive={activeSelect === name} inputWidth={inputWidth}>
        <input type="text" id={"text"} onChange={handleChange} value={text?.text || ""} name={"text"} autoComplete="off"/> 
        <label htmlFor={"text"}>{labelText}{isRequired && "*"}</label>
        <MdKeyboardArrowRight className="arr-icon"/>
            {
                activeSelect === name &&
                <div className="options">
                    {
                        options.map((item) => (
                            <div key={item.id} className="option" onClick={() => handleOptionClick(item)}>
                                {item.text}
                            </div>
                        ))
                    }
                </div>
            }
    </Container>
  )
}

export default InputTonaj